import { useCallback, useState } from 'react';
import MediaServicesSearchClient from '@foundation/media-services-search-client';
import throttle from 'lodash.throttle';

import { SearchResults } from '../types';
import { getSearchResults } from '../utils/search';

export const useFetchThrottledSearchResults = (waitTimer: number = 100) => {
  const [searchResults, setSearchResults] = useState<SearchResults | undefined>(
    undefined
  );

  const fetchThrottledSearchResults = useCallback(
    throttle(
      async (
        inputValue: string,
        searchClient: MediaServicesSearchClient,
        countryCode: string
      ) => {
        if (!inputValue || !inputValue.trim()) return;

        const results = await getSearchResults(
          inputValue,
          searchClient,
          countryCode
        );

        setSearchResults(results);
      },
      waitTimer,
      { leading: false, trailing: true }
    ),
    []
  );

  return [searchResults, fetchThrottledSearchResults] as const;
};
